import styled from 'styled-components';
import tornEdges from '../../../../../assets/illustrations/torne-edge.svg';

export const TornEdge = styled.div`
  width: 100%;
  height: 10px; /* Adjust based on your SVG height */
  background-image: url(${tornEdges});
  background-repeat: repeat-x;
  background-size: contain;
  position: absolute;
  left: 0;
`;

export const TornEdgeTop = styled(TornEdge)`
  top: -9px;
  transform: translateY(1px);
`;

export const TornEdgeBottom = styled(TornEdge)`
  bottom: -9px;
  transform: rotate(180deg) translateY(1px);
`;

export const CardContainer = styled.div`
  position: relative;
`;

export const Card = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 2px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  gap: 8px;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-item: flex-start;
  width: 100%;
  padding: 16px 16px 24px 16px;
  gap: 10px;
`;

export const CardList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: black;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  list-style-type: disc;
  li {
    margin-left: 20px;
  }
`;

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  color: black;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const CardText = styled.p`
  color: black;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px;
`;

export const Separator = styled.div<{
  dark?: boolean;
}>`
  width: 100%;
  border: 1px solid ${(props) => (props.dark ? 'black' : '#BFD8E9')};
`;
